import React from "react";
import BlockContent from "@sanity/block-content-to-react";
import { format } from "date-fns";
import { Link } from "react-router-dom";

function BlogPost({ post, postImage, allCategories, allPosts }) {
  if (!post) return <p>Loading...</p>; // Comprobar si los datos del post están disponibles

  const {
    title,
    author,
    publishedAt,
    mainImage,
    content,
    categories,
    excerpt,
  } = post;

  const imageUrl = mainImage ? postImage(mainImage.asset._ref) : null; // Usar la URL de la imagen

  return (
    <section className="blog-details-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="standard-blog-item mb-50">
              <div className="standard-blog-thumb">
                {imageUrl && <img src={imageUrl} alt={title} />}
              </div>
              <div className="standard-blog-content blog-details-content">
                <div className="blog-post-meta">
                  <ul>
                    <li className="tags">
                      <i className="flaticon-bookmark-1" />
                      {categories?.map((category, index) => (
                        <a href="/#" key={index}>
                          {category.title}
                          {index < categories.length - 1 && ", "}
                        </a>
                      ))}
                    </li>
                    <li>
                      <i className="far fa-user" />
                      <a href="/#">{author}</a>
                    </li>
                    <li>
                      <i className="far fa-bell" />
                      {format(publishedAt, "MMMM dd, yyyy")}
                    </li>
                  </ul>
                </div>
                <h4 className="title">{title}</h4>
                <p>{excerpt}</p>
                <div className="blog-content">
                  <BlockContent blocks={content} />
                </div>
                <div className="blog-details-img">
                  <div className="row">
                    {/* Si tienes imágenes adicionales en el contenido, puedes renderizarlas aquí */}
                  </div>
                </div>
                <div
                  className="blog-line"
                  data-background="img/blog/blog_item_line.png"
                />
                <div className="blog-details-bottom">
                  <div className="blog-details-tags">
                    <ul>
                      <li className="title">
                        <i className="fas fa-tags" /> Tags :
                      </li>
                      {categories?.map((category, index) => (
                        <li key={index}>
                          <a href="/#">{category.title}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="blog-details-social">
                    <ul>
                      <li>
                        <a href="/#">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href="/#">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <aside className="blog-sidebar">
              <div className="widget">
                <h4 className="sidebar-title">Posts Recientes</h4>
                <div className="rc-post-list">
                  <ul>
                    {allPosts?.map((post) => (
                      <li key={post._id}>
                        <div className="rc-post-thumb">
                          <Link to={`/blog/${post._id}`}>
                            <img
                              src={postImage(post.mainImage.asset._ref)}
                              alt=""
                            />
                          </Link>
                        </div>
                        <div className="rc-post-content">
                          <h5 className="title">
                            <Link to={`/blog/${post._id}`}>{post.title}</Link>
                          </h5>
                          <div className="rc-post-meta">
                            <ul>
                              <li>
                                <i className="far fa-calendar-alt" />
                                {format(post.publishedAt, "MMMM dd, yyyy")}
                              </li>
                              <li>
                                By <a href="/#">{post.author}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="widget sidebar-newsletter">
                <div className="sn-icon">
                  <img src="img/icon/sn_icon.png" alt="" />
                </div>
                <div className="sn-title">
                  <h4 className="title">Subscribirse a nuestra Newsletter</h4>
                </div>
                <form className="sn-form">
                  <input type="text" placeholder="Ingresa tu e-mail" />
                  <button className="btn">Subscribirse</button>
                </form>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BlogPost;
